import {
  Department_Read_Typeahead,
  getV1CompaniesCompanyIdDepartmentsTypeahead,
  GetV1CompaniesCompanyIdDepartmentsTypeaheadData,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { DepartmentTypeahead } from '~hooks/useDepartment/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Department_Read_Typeahead,
  DepartmentTypeahead,
  GetV1CompaniesCompanyIdDepartmentsTypeaheadData
> & { companyId: string };

export default function AutocompleteDepartmentsTypeahead<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteDepartmentsTypeahead"
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        request: getV1CompaniesCompanyIdDepartmentsTypeahead,
      }}
      parseFn={(item: Department_Read_Typeahead) => {
        const parsed = DepartmentTypeahead.parse(item);

        return { _entity: parsed, label: parsed.name, value: parsed.id };
      }}
    />
  );
}
